type PopularName = {
  name: string;
  url: string;
  count: number;
};
export type PopularNames = PopularName[];

export enum PageNamesTypes {
  profile = 'PeopleProfileItem',
  child = 'PeopleChildItem',
  userBag = 'PeopleUserBagItem',
}

export type PeopleProfileItemFields = {
  name: string;
  photoUrl: string;
  coach: boolean;
  url: string;
  occupationTitle: string;
  city: string;
};

export type PeopleProfileItem = PeopleProfileItemFields & {
  __typename: PageNamesTypes.profile;
};

export type PeopleProfileItems = PeopleProfileItem[];

export type PeopleChildItemFields = {
  name: string;
  toName: string;
  url: string;
};

export type PeopleChildItem = PeopleChildItemFields & {
  __typename: PageNamesTypes.child;
};
export type PeopleChildItems = PeopleChildItem[];

export type PeopleUserBagItemFields = {
  name: string;
  url: string;
  count: number;
};
export type PeopleUserBagItem = PeopleUserBagItemFields & {
  __typename: PageNamesTypes.userBag;
};
export type PeopleUserBagItems = PeopleUserBagItem[];

export type PageNames =
  | PeopleProfileItems
  | PeopleChildItems
  | PeopleUserBagItems;

export type PageName = PeopleProfileItem | PeopleChildItem | PeopleUserBagItem;

export type ExampleNames = {
  name: string;
  url: string;
};
